import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  .component_team_info_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }

  .component_info_btn {
    padding-right: 17px;
    padding-left: 17px;

    .anticon {
      margin-right: 12px;
    }
  }

  .ant-avatar {
    margin-right: 4px;
  }

  .component_team_info_box:nth-child(1) {
    width: 318px;
  }

  .component_team_info_content_title {
    margin-bottom: 4px;
  }

  .component_team_license_box {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .component_team_license_text {
    span:nth-child(1) {
      margin-right: 10px;
    }
  }

  .component_team_info_badge {
    margin-right: 82px;
  }

  .ant-avatar {
    background-color: ${color.orange6};
    color: ${color.orange1};
    border: 1px solid ${color.grey1};
    .ant-avatar-string {
      font-size: 12px;
    }
  }
`;

export default Wrapper;

export const CreateFormWrapper = styled.div`
  .ant-form-item {
    margin-bottom: 24px;
    .ant-form-item-label {
      padding: 0 0 6px;
      > label {
        color: ${color.black3};
        font-weight: 600;
        font-size: 16px;
        line-height: 142%;
      }
    }
  }
  .ant-form-item-control-input-content {
    input {
      background-color: unset;
      border: 1px solid ${color.grey5};
      padding: 0 16px;
      height: 44px;
    }
    textarea {
      padding: 8px 16px;
      min-height: 132px;
    }
    .ant-select-selector {
      padding: 0 16px;
    }
  }
`;

export const OptionRender = styled.div`
  display: flex;
  align-items: center;
  .component_accountCard {
    margin: auto 0;
    width: 100%;
    padding: 6px 4px;
    .ant-avatar {
      height: 32px !important;
      width: 32px !important;
      .ant-avatar-string {
        line-height: 32px !important;
        font-size: 14px;
      }
    }
    .font-paragraph_medium {
      font-size: 16px;
      font-weight: 400;
    }
  }
`;
